export const LOGIN_PATH = '/login';
export const REGISTRATION_PATH = '/sign-up';

export const authPaths = [
  '/home',
  LOGIN_PATH,
  '/new/sign-in',
  `${LOGIN_PATH}/confirmation-code`,
  '/signup',
  '/new/signup',
  '/new/sign-up',
  `${REGISTRATION_PATH}/fill-name`,
  `${REGISTRATION_PATH}/instagram`,
  `${REGISTRATION_PATH}/phone`,
  `${REGISTRATION_PATH}/confirmation-code`,
] as const;

export type AuthPath = (typeof authPaths)[number];

export const authPath = <TPath extends AuthPath>(value: TPath): TPath => value;
